import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SubscriptionCheckoutModal from '../../componentes/SubscriptionModal';

const PLAN_CONFIG = {
    plus:    { planName: 'Plano Plus - Mensal',    name: 'Plus',    amount: 12.90 },
    premium: { planName: 'Plano Premium - Mensal', name: 'Premium', amount: 21.90 },
};

function postToApp(payload) {
    if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
}

export default function MobileCheckout() {
    const [searchParams] = useSearchParams();
    const [ready, setReady] = useState(false);
    const [preRegisterData, setPreRegisterData] = useState(null);

    const token   = searchParams.get('token');
    const planId  = searchParams.get('plan');
    const mode    = searchParams.get('mode') || 'upgrade'; // 'upgrade' | 'register'
    const plan    = PLAN_CONFIG[planId];

    const isRegisterMode = mode === 'register';

    // Modo upgrade: token vem por query param (usuário já tem conta)
    useEffect(() => {
        if (!isRegisterMode && token) {
            localStorage.setItem('token', JSON.stringify(token));
        }
        if (!isRegisterMode) setReady(true);
    }, [isRegisterMode, token]);

    // Modo register: os dados do formulário chegam via postMessage do app
    // (nunca pela URL, pra não expor a senha em query string/histórico)
    useEffect(() => {
        if (!isRegisterMode) return;

        function handleAppMessage(event) {
            try {
                const payload = JSON.parse(event.data);
                if (payload?.type === 'preRegisterData' && payload.data) {
                    setPreRegisterData(payload.data);
                    setReady(true);
                }
            } catch {
                // mensagem que não é JSON válido — ignora
            }
        }

        // O react-native-webview dispara o evento tanto em document quanto
        // em window, dependendo da plataforma — escuta os dois pra garantir.
        document.addEventListener('message', handleAppMessage);
        window.addEventListener('message', handleAppMessage);
        return () => {
            document.removeEventListener('message', handleAppMessage);
            window.removeEventListener('message', handleAppMessage);
        };
    }, [isRegisterMode]);

    function handleSuccess() {
        // Em ambos os modos, authUser() (dentro do SubscriptionCheckoutModal)
        // já deixou o token salvo no localStorage — só repassa pro app.
        const savedToken = localStorage.getItem('token');
        const parsedToken = savedToken ? JSON.parse(savedToken) : null;
        postToApp({ type: 'success', token: parsedToken });
    }

    if (!ready) {
        return (
            <div style={styles.page}>
                <div style={styles.center}>
                    <p style={styles.hintText}>Carregando checkout...</p>
                </div>
            </div>
        );
    }

    if (!plan || (isRegisterMode && !preRegisterData)) {
        return (
            <div style={styles.page}>
                <div style={styles.center}>
                    <p style={styles.errorText}>Link de checkout inválido.</p>
                </div>
            </div>
        );
    }

    return (
        <div style={styles.page}>
            <SubscriptionCheckoutModal
                plan={plan}
                payerEmail={isRegisterMode ? preRegisterData.email : ''}
                preRegisterData={isRegisterMode ? preRegisterData : undefined}
                onClose={() => postToApp({ type: 'cancelled' })}
                onSuccess={handleSuccess}
            />
        </div>
    );
}

const styles = {
    page: {
        position: 'fixed',
        inset: 0,
        background: '#0a0a14',
        zIndex: 2000,
    },
    center: {
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    errorText: {
        color: '#f87171',
        fontSize: 14,
    },
    hintText: {
        color: '#a3a3c2',
        fontSize: 14,
    },
};